export const extenStatus = {
  UnKnow:'UnKnow',
  Idle:'Idle',
  Ring:'Ringing',
  Talk:'Talking',
  Offline:'OffLine',
  Broad:'Broading',
}

export const participantType = {
  SIP:'sip',
  CAMERA:'camera',
  PC:'pc'
}




// WEBPACK FOOTER //
// ./src/libs/enum.js